import React from 'react';

import { AppContext, AppService } from '../context';

export function useApp(): AppService {
  return React.useContext(AppContext);
}
